import { CancelToken } from 'axios';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../store';
import { getOptionsInvitation, selectOptionsInvitation, selectOptionsInvitationState } from '../../../store/entities/optionsInvitation';
import { FetchState } from '../../../store/fetchState';
import { getLangNameObj } from '../../../utils/format';
import { QcsAutocompleteWithoutFormik } from '../form/QcsAutocompleteWithoutFormik';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';

interface Props {
  value?: ReferenceDto[];
  onChange: (value?: ReferenceDto) => void;
}

export const GridFilterInvitationMultiple: FC<Props> = ({ value = [], onChange }) => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const optionsInvitation = useAppSelector(selectOptionsInvitation);
  const optionsInvitationState = useAppSelector(selectOptionsInvitationState);

  const loadOptions = (search: string | undefined, cancelToken: CancelToken) => {
    dispatch(getOptionsInvitation(search, cancelToken));
  };

  const handleChange = (value?: ReferenceDto | ReferenceDto[] | null) => {
    onChange((value as ReferenceDto) ?? undefined);
  };

  return (
    <QcsAutocompleteWithoutFormik
      multiple
      options={optionsInvitation}
      loading={optionsInvitationState === FetchState.Loading}
      loadingError={optionsInvitationState === FetchState.Error}
      loadOptions={loadOptions}
      value={value}
      getOptionId={(option: ReferenceDto) => option.id!}
      getOptionName={(option: ReferenceDto) => getLangNameObj(i18n, option)}
      onChange={handleChange}
    />
  );
};
